// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkout {
  padding-top: 1.5rem;
  padding-bottom: 2.5rem;
  min-width: 0;
}

.checkout__page-title {
  margin: 0 0 1.25rem 0;
  font-family: 'Neucha', cursive;
  font-size: 2rem;
  font-weight: 400;
  color: #4e3f3a;
}

.checkout__layout {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
  align-items: start;
  min-width: 0;
}

@media (max-width: 900px) {
  .checkout__layout {
    grid-template-columns: 1fr;
  }
}

.checkout__column {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  min-width: 0;
}

.checkout__section {
  background: #fff;
  border: 2px solid #a78c83;
  border-radius: 24px;
  padding: 1.25rem 1.25rem 1.5rem;
  min-width: 0;
}

.checkout__section--pay {
  margin-top: 0.5rem;
}

.checkout__restaurant-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.checkout__restaurant-btn {
  width: 100%;
  text-align: left;
  padding: 0.75rem 1rem;
  border: 2px solid #e8e4df;
  border-radius: 12px;
  background: #fff;
  color: #4e3f3a;
  font-family: 'Roboto', sans-serif;
  font-size: 0.9375rem;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;
}

.checkout__restaurant-btn:hover {
  border-color: #a78c83;
}

.checkout__restaurant-btn--active {
  border-color: #a78c83;
  background: #faf7f5;
  font-weight: 600;
}

.checkout__section-title {
  margin: 0 0 1rem 0;
  font-family: 'Roboto', sans-serif;
  font-weight: 600;
  font-size: 1.125rem;
  color: #4e3f3a;
}

.checkout__cart-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.checkout__cart-row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid #e8e4df;
}

.checkout__cart-row:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.checkout__cart-info {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  min-width: 0;
  flex: 1;
}

.checkout__cart-name {
  font-family: 'Roboto', sans-serif;
  font-size: 0.9375rem;
  color: #4e3f3a;
}

.checkout__cart-meta {
  font-size: 0.8125rem;
  color: #6b5d58;
}

.checkout__cart-bonus {
  display: block;
  font-size: 0.75rem;
  color: #7a6b4a;
  margin-top: 0.15rem;
}

.checkout__cart-controls {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
  min-width: 0;
}

.checkout__qty-btn {
  width: 32px;
  height: 32px;
  border: 2px solid #a78c83;
  border-radius: 10px;
  background: #f3e3cc;
  font-size: 1.125rem;
  line-height: 1;
  cursor: pointer;
  color: #4e3f3a;
}

.checkout__qty-btn:hover {
  background: #ebe0d0;
}

.checkout__qty-value {
  min-width: 1.5rem;
  text-align: center;
  font-family: 'Roboto', sans-serif;
  font-size: 0.9375rem;
}

.checkout__remove-btn {
  margin-left: 0.25rem;
  padding: 0.35rem 0.65rem;
  border: none;
  background: transparent;
  font-family: 'Roboto', sans-serif;
  font-size: 0.8125rem;
  color: #991b1b;
  text-decoration: underline;
  cursor: pointer;
}

.checkout__totals {
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.checkout__total {
  margin: 0;
  font-family: 'Roboto', sans-serif;
  font-size: 1.125rem;
  color: #4e3f3a;
}

.checkout__total--discount {
  font-size: 1rem;
  color: #166534;
}

.checkout__total--final {
  font-size: 1.25rem;
  font-weight: 600;
}

.checkout__hint-inline {
  font-size: 0.85rem;
  font-weight: 400;
  opacity: 0.85;
}

.checkout__promo-row {
  display: flex;
  gap: 0.5rem;
  align-items: stretch;
  min-width: 0;
}

.checkout__promo-row input {
  flex: 1;
  min-width: 0;
}

.checkout__promo-apply {
  flex-shrink: 0;
  padding: 0.5rem 0.85rem;
  border: 1px solid #a78c83;
  border-radius: 12px;
  background: #faf7f4;
  font-family: 'Roboto', sans-serif;
  font-size: 0.875rem;
  color: #4e3f3a;
  cursor: pointer;
}

.checkout__promo-apply:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.checkout__field {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  margin-bottom: 1rem;
}

.checkout__field label,
.checkout__field-label-static {
  font-family: 'Roboto', sans-serif;
  font-weight: 600;
  font-size: 0.875rem;
  color: #4e3f3a;
}

.checkout__field-label-static {
  display: block;
  margin-bottom: 0.35rem;
}

.checkout__address-open {
  width: 100%;
  text-align: left;
  padding: 0.625rem 0.875rem;
  border: 1px solid #e8e4df;
  border-radius: 12px;
  background: #fff;
  font-family: 'Roboto', sans-serif;
  font-size: 0.9375rem;
  color: #4e3f3a;
  cursor: pointer;
  line-height: 1.35;
}

.checkout__address-open:hover {
  background: #faf7f4;
}

.checkout__field input,
.checkout__field select,
.checkout__field textarea {
  font-family: 'Roboto', sans-serif;
  font-size: 0.9375rem;
  padding: 0.625rem 0.875rem;
  border: 1px solid #e8e4df;
  border-radius: 12px;
  background: #fff;
  color: #4e3f3a;
}

.checkout__field textarea {
  resize: vertical;
  min-height: 72px;
}

.checkout__toggle {
  margin-bottom: 1rem;
}

.checkout__hint {
  margin: 0 0 0.75rem 0;
  font-size: 0.875rem;
  color: #6b5d58;
}

.checkout__error-msg {
  margin: 0 0 0.75rem 0;
  font-size: 0.875rem;
  color: #991b1b;
}

.checkout__warning-msg {
  margin: 0 0 0.75rem 0;
  padding: 8px 12px;
  background: #fff3cd;
  border: 1px solid #ffe69c;
  color: #664d03;
  border-radius: 8px;
  font-size: 0.875rem;
  line-height: 1.4;
}

.checkout__cart-row--unavailable {
  background: #faf2f2;
  border-radius: 8px;
}

.checkout__cart-row--unavailable .checkout__cart-name,
.checkout__cart-row--unavailable .checkout__cart-meta {
  color: #8a7a72;
  text-decoration: line-through;
}

.checkout__cart-unavailable {
  display: block;
  margin-top: 4px;
  font-size: 0.75rem;
  color: #b32129;
  font-weight: 500;
}

.checkout__pay-hint {
  margin: 0 0 1rem 0;
  font-size: 0.875rem;
  color: #6b5d58;
  line-height: 1.45;
}

.checkout__error {
  margin-bottom: 0.75rem;
}

.checkout__submit {
  width: 100%;
  padding: 0.875rem 1rem;
  border: none;
  border-radius: 24px;
  background: #ff9702;
  font-family: 'Roboto', sans-serif;
  font-size: 1.0625rem;
  font-weight: 600;
  color: #4e3f3a;
  cursor: pointer;
}

.checkout__submit:hover:not(:disabled) {
  filter: brightness(1.03);
}

.checkout__submit:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.checkout__card {
  max-width: 480px;
  margin: 0 auto;
}

.checkout__card--success {
  background: #fff;
  border: 2px solid #a78c83;
  border-radius: 24px;
  padding: 2rem 1.5rem;
  text-align: center;
}

.checkout__title {
  margin: 0 0 1rem 0;
  font-family: 'Neucha', cursive;
  font-size: 1.75rem;
  font-weight: 400;
  color: #4e3f3a;
}

.checkout__success-text {
  margin: 0 0 0.75rem 0;
  font-family: 'Roboto', sans-serif;
  font-size: 1rem;
  color: #4e3f3a;
}

.checkout__success-hint {
  margin: 0 0 1.5rem 0;
  font-size: 0.875rem;
  color: #6b5d58;
  line-height: 1.45;
}

.checkout__link-home {
  display: inline-block;
  font-family: 'Roboto', sans-serif;
  font-weight: 600;
  color: #4e3f3a;
}

.checkout__bonus-toggle {
  display: flex;
  gap: 0.5rem;
  margin: 0.75rem 0 0.5rem;
}

.checkout__bonus-btn {
  flex: 1;
  padding: 0.5rem 0.75rem;
  border: 2px solid #c4b4a8;
  border-radius: 12px;
  background: #faf7f4;
  font-family: 'Roboto', sans-serif;
  font-size: 0.9rem;
  cursor: pointer;
  color: #4e3f3a;
}

.checkout__bonus-btn--active {
  border-color: #a78c83;
  background: #f3e3cc;
  font-weight: 600;
}

@media (max-width: 768px) {
  .checkout {
    padding-top: 1rem;
    padding-bottom: 1.5rem;
  }

  .checkout__section {
    border-radius: 18px;
    padding: 0.95rem 0.9rem 1.1rem;
  }

  .checkout__cart-row {
    gap: 0.5rem;
  }

  .checkout__cart-controls {
    flex-wrap: wrap;
    width: 100%;
  }

  .checkout__remove-btn {
    margin-left: 0;
    padding-left: 0;
  }

  .checkout__promo-row {
    flex-wrap: wrap;
  }

  .checkout__promo-apply {
    width: 100%;
  }

  .checkout__toggle.cart__toggle-wrap {
    height: auto;
    min-height: 42px;
    padding: 3px;
  }

  .checkout__toggle .cart__toggle-btn {
    font-size: 15px;
    line-height: 1.2;
  }

  .checkout__bonus-toggle {
    flex-wrap: wrap;
  }

  .checkout__bonus-btn {
    flex: 1 1 100%;
  }
}

@media (max-width: 430px) {
  .checkout__page-title {
    font-size: 1.6rem;
    margin-bottom: 0.8rem;
  }

  .checkout__layout {
    gap: 0.9rem;
  }

  .checkout__section-title {
    font-size: 1rem;
    margin-bottom: 0.75rem;
  }

  .checkout__total {
    font-size: 1rem;
  }

  .checkout__total--final {
    font-size: 1.1rem;
  }

  .checkout__field input,
  .checkout__field select,
  .checkout__field textarea,
  .checkout__address-open {
    font-size: 0.875rem;
    padding: 0.56rem 0.72rem;
  }

  .checkout__submit {
    border-radius: 16px;
    font-size: 1rem;
    padding: 0.75rem 0.9rem;
  }
}

.checkout__checkbox-label {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  cursor: pointer;
}

.checkout__checkbox-label input[type='checkbox'] {
  flex-shrink: 0;
  margin-top: 0.2em;
}

.checkout__checkbox-label--disabled {
  opacity: 0.85;
  cursor: not-allowed;
  user-select: none;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Checkout.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,iCAAiC;EACjC,oBAAoB;EACpB,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;EACZ,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,OAAO;AACT;;AAEA;EACE,iCAAiC;EACjC,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,wBAAwB;EACxB,YAAY;EACZ,uBAAuB;EACvB,iCAAiC;EACjC,oBAAoB;EACpB,cAAc;EACd,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,iCAAiC;EACjC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,WAAW;EACX,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,iCAAiC;EACjC,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,iCAAiC;EACjC,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,0BAA0B;EAC1B,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,iCAAiC;EACjC,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,iCAAiC;EACjC,oBAAoB;EACpB,0BAA0B;EAC1B,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,iCAAiC;EACjC,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,iCAAiC;EACjC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,iCAAiC;EACjC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,OAAO;EACP,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,iCAAiC;EACjC,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE;IACE,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;;;IAIE,mBAAmB;IACnB,wBAAwB;EAC1B;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,uBAAuB;EACzB;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB","sourcesContent":[".checkout {\n  padding-top: 1.5rem;\n  padding-bottom: 2.5rem;\n  min-width: 0;\n}\n\n.checkout__page-title {\n  margin: 0 0 1.25rem 0;\n  font-family: 'Neucha', cursive;\n  font-size: 2rem;\n  font-weight: 400;\n  color: #4e3f3a;\n}\n\n.checkout__layout {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1.5rem;\n  align-items: start;\n  min-width: 0;\n}\n\n@media (max-width: 900px) {\n  .checkout__layout {\n    grid-template-columns: 1fr;\n  }\n}\n\n.checkout__column {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  min-width: 0;\n}\n\n.checkout__section {\n  background: #fff;\n  border: 2px solid #a78c83;\n  border-radius: 24px;\n  padding: 1.25rem 1.25rem 1.5rem;\n  min-width: 0;\n}\n\n.checkout__section--pay {\n  margin-top: 0.5rem;\n}\n\n.checkout__restaurant-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.checkout__restaurant-btn {\n  width: 100%;\n  text-align: left;\n  padding: 0.75rem 1rem;\n  border: 2px solid #e8e4df;\n  border-radius: 12px;\n  background: #fff;\n  color: #4e3f3a;\n  font-family: 'Roboto', sans-serif;\n  font-size: 0.9375rem;\n  cursor: pointer;\n  transition: border-color 0.15s ease, background 0.15s ease;\n}\n\n.checkout__restaurant-btn:hover {\n  border-color: #a78c83;\n}\n\n.checkout__restaurant-btn--active {\n  border-color: #a78c83;\n  background: #faf7f5;\n  font-weight: 600;\n}\n\n.checkout__section-title {\n  margin: 0 0 1rem 0;\n  font-family: 'Roboto', sans-serif;\n  font-weight: 600;\n  font-size: 1.125rem;\n  color: #4e3f3a;\n}\n\n.checkout__cart-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.checkout__cart-row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.75rem;\n  padding-bottom: 0.75rem;\n  border-bottom: 1px solid #e8e4df;\n}\n\n.checkout__cart-row:last-child {\n  border-bottom: none;\n  padding-bottom: 0;\n}\n\n.checkout__cart-info {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  min-width: 0;\n  flex: 1;\n}\n\n.checkout__cart-name {\n  font-family: 'Roboto', sans-serif;\n  font-size: 0.9375rem;\n  color: #4e3f3a;\n}\n\n.checkout__cart-meta {\n  font-size: 0.8125rem;\n  color: #6b5d58;\n}\n\n.checkout__cart-bonus {\n  display: block;\n  font-size: 0.75rem;\n  color: #7a6b4a;\n  margin-top: 0.15rem;\n}\n\n.checkout__cart-controls {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  flex-shrink: 0;\n  min-width: 0;\n}\n\n.checkout__qty-btn {\n  width: 32px;\n  height: 32px;\n  border: 2px solid #a78c83;\n  border-radius: 10px;\n  background: #f3e3cc;\n  font-size: 1.125rem;\n  line-height: 1;\n  cursor: pointer;\n  color: #4e3f3a;\n}\n\n.checkout__qty-btn:hover {\n  background: #ebe0d0;\n}\n\n.checkout__qty-value {\n  min-width: 1.5rem;\n  text-align: center;\n  font-family: 'Roboto', sans-serif;\n  font-size: 0.9375rem;\n}\n\n.checkout__remove-btn {\n  margin-left: 0.25rem;\n  padding: 0.35rem 0.65rem;\n  border: none;\n  background: transparent;\n  font-family: 'Roboto', sans-serif;\n  font-size: 0.8125rem;\n  color: #991b1b;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.checkout__totals {\n  margin-top: 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.checkout__total {\n  margin: 0;\n  font-family: 'Roboto', sans-serif;\n  font-size: 1.125rem;\n  color: #4e3f3a;\n}\n\n.checkout__total--discount {\n  font-size: 1rem;\n  color: #166534;\n}\n\n.checkout__total--final {\n  font-size: 1.25rem;\n  font-weight: 600;\n}\n\n.checkout__hint-inline {\n  font-size: 0.85rem;\n  font-weight: 400;\n  opacity: 0.85;\n}\n\n.checkout__promo-row {\n  display: flex;\n  gap: 0.5rem;\n  align-items: stretch;\n  min-width: 0;\n}\n\n.checkout__promo-row input {\n  flex: 1;\n  min-width: 0;\n}\n\n.checkout__promo-apply {\n  flex-shrink: 0;\n  padding: 0.5rem 0.85rem;\n  border: 1px solid #a78c83;\n  border-radius: 12px;\n  background: #faf7f4;\n  font-family: 'Roboto', sans-serif;\n  font-size: 0.875rem;\n  color: #4e3f3a;\n  cursor: pointer;\n}\n\n.checkout__promo-apply:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.checkout__field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  margin-bottom: 1rem;\n}\n\n.checkout__field label,\n.checkout__field-label-static {\n  font-family: 'Roboto', sans-serif;\n  font-weight: 600;\n  font-size: 0.875rem;\n  color: #4e3f3a;\n}\n\n.checkout__field-label-static {\n  display: block;\n  margin-bottom: 0.35rem;\n}\n\n.checkout__address-open {\n  width: 100%;\n  text-align: left;\n  padding: 0.625rem 0.875rem;\n  border: 1px solid #e8e4df;\n  border-radius: 12px;\n  background: #fff;\n  font-family: 'Roboto', sans-serif;\n  font-size: 0.9375rem;\n  color: #4e3f3a;\n  cursor: pointer;\n  line-height: 1.35;\n}\n\n.checkout__address-open:hover {\n  background: #faf7f4;\n}\n\n.checkout__field input,\n.checkout__field select,\n.checkout__field textarea {\n  font-family: 'Roboto', sans-serif;\n  font-size: 0.9375rem;\n  padding: 0.625rem 0.875rem;\n  border: 1px solid #e8e4df;\n  border-radius: 12px;\n  background: #fff;\n  color: #4e3f3a;\n}\n\n.checkout__field textarea {\n  resize: vertical;\n  min-height: 72px;\n}\n\n.checkout__toggle {\n  margin-bottom: 1rem;\n}\n\n.checkout__hint {\n  margin: 0 0 0.75rem 0;\n  font-size: 0.875rem;\n  color: #6b5d58;\n}\n\n.checkout__error-msg {\n  margin: 0 0 0.75rem 0;\n  font-size: 0.875rem;\n  color: #991b1b;\n}\n\n.checkout__warning-msg {\n  margin: 0 0 0.75rem 0;\n  padding: 8px 12px;\n  background: #fff3cd;\n  border: 1px solid #ffe69c;\n  color: #664d03;\n  border-radius: 8px;\n  font-size: 0.875rem;\n  line-height: 1.4;\n}\n\n.checkout__cart-row--unavailable {\n  background: #faf2f2;\n  border-radius: 8px;\n}\n\n.checkout__cart-row--unavailable .checkout__cart-name,\n.checkout__cart-row--unavailable .checkout__cart-meta {\n  color: #8a7a72;\n  text-decoration: line-through;\n}\n\n.checkout__cart-unavailable {\n  display: block;\n  margin-top: 4px;\n  font-size: 0.75rem;\n  color: #b32129;\n  font-weight: 500;\n}\n\n.checkout__pay-hint {\n  margin: 0 0 1rem 0;\n  font-size: 0.875rem;\n  color: #6b5d58;\n  line-height: 1.45;\n}\n\n.checkout__error {\n  margin-bottom: 0.75rem;\n}\n\n.checkout__submit {\n  width: 100%;\n  padding: 0.875rem 1rem;\n  border: none;\n  border-radius: 24px;\n  background: #ff9702;\n  font-family: 'Roboto', sans-serif;\n  font-size: 1.0625rem;\n  font-weight: 600;\n  color: #4e3f3a;\n  cursor: pointer;\n}\n\n.checkout__submit:hover:not(:disabled) {\n  filter: brightness(1.03);\n}\n\n.checkout__submit:disabled {\n  opacity: 0.65;\n  cursor: not-allowed;\n}\n\n.checkout__card {\n  max-width: 480px;\n  margin: 0 auto;\n}\n\n.checkout__card--success {\n  background: #fff;\n  border: 2px solid #a78c83;\n  border-radius: 24px;\n  padding: 2rem 1.5rem;\n  text-align: center;\n}\n\n.checkout__title {\n  margin: 0 0 1rem 0;\n  font-family: 'Neucha', cursive;\n  font-size: 1.75rem;\n  font-weight: 400;\n  color: #4e3f3a;\n}\n\n.checkout__success-text {\n  margin: 0 0 0.75rem 0;\n  font-family: 'Roboto', sans-serif;\n  font-size: 1rem;\n  color: #4e3f3a;\n}\n\n.checkout__success-hint {\n  margin: 0 0 1.5rem 0;\n  font-size: 0.875rem;\n  color: #6b5d58;\n  line-height: 1.45;\n}\n\n.checkout__link-home {\n  display: inline-block;\n  font-family: 'Roboto', sans-serif;\n  font-weight: 600;\n  color: #4e3f3a;\n}\n\n.checkout__bonus-toggle {\n  display: flex;\n  gap: 0.5rem;\n  margin: 0.75rem 0 0.5rem;\n}\n\n.checkout__bonus-btn {\n  flex: 1;\n  padding: 0.5rem 0.75rem;\n  border: 2px solid #c4b4a8;\n  border-radius: 12px;\n  background: #faf7f4;\n  font-family: 'Roboto', sans-serif;\n  font-size: 0.9rem;\n  cursor: pointer;\n  color: #4e3f3a;\n}\n\n.checkout__bonus-btn--active {\n  border-color: #a78c83;\n  background: #f3e3cc;\n  font-weight: 600;\n}\n\n@media (max-width: 768px) {\n  .checkout {\n    padding-top: 1rem;\n    padding-bottom: 1.5rem;\n  }\n\n  .checkout__section {\n    border-radius: 18px;\n    padding: 0.95rem 0.9rem 1.1rem;\n  }\n\n  .checkout__cart-row {\n    gap: 0.5rem;\n  }\n\n  .checkout__cart-controls {\n    flex-wrap: wrap;\n    width: 100%;\n  }\n\n  .checkout__remove-btn {\n    margin-left: 0;\n    padding-left: 0;\n  }\n\n  .checkout__promo-row {\n    flex-wrap: wrap;\n  }\n\n  .checkout__promo-apply {\n    width: 100%;\n  }\n\n  .checkout__toggle.cart__toggle-wrap {\n    height: auto;\n    min-height: 42px;\n    padding: 3px;\n  }\n\n  .checkout__toggle .cart__toggle-btn {\n    font-size: 15px;\n    line-height: 1.2;\n  }\n\n  .checkout__bonus-toggle {\n    flex-wrap: wrap;\n  }\n\n  .checkout__bonus-btn {\n    flex: 1 1 100%;\n  }\n}\n\n@media (max-width: 430px) {\n  .checkout__page-title {\n    font-size: 1.6rem;\n    margin-bottom: 0.8rem;\n  }\n\n  .checkout__layout {\n    gap: 0.9rem;\n  }\n\n  .checkout__section-title {\n    font-size: 1rem;\n    margin-bottom: 0.75rem;\n  }\n\n  .checkout__total {\n    font-size: 1rem;\n  }\n\n  .checkout__total--final {\n    font-size: 1.1rem;\n  }\n\n  .checkout__field input,\n  .checkout__field select,\n  .checkout__field textarea,\n  .checkout__address-open {\n    font-size: 0.875rem;\n    padding: 0.56rem 0.72rem;\n  }\n\n  .checkout__submit {\n    border-radius: 16px;\n    font-size: 1rem;\n    padding: 0.75rem 0.9rem;\n  }\n}\n\n.checkout__checkbox-label {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.5rem;\n  cursor: pointer;\n}\n\n.checkout__checkbox-label input[type='checkbox'] {\n  flex-shrink: 0;\n  margin-top: 0.2em;\n}\n\n.checkout__checkbox-label--disabled {\n  opacity: 0.85;\n  cursor: not-allowed;\n  user-select: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
